import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import {NavigateFunction} from "react-router-dom";

import {apiRequestDownloads} from "../../api/apiRequests";
import {EBook} from "../eLibrary/eLibrarySlice";
import {checkRedirect} from "../login/RequireAuth";
import {defaultPagination, PaginationInterface} from "../ui/Pagination";

export interface DownloadsState {
  downloads: EBook[],
  downloadsStatus: string,
  pagination: PaginationInterface,
}

const initialState: DownloadsState = {
  downloads: [],
  downloadsStatus: "",
  pagination: {...defaultPagination}
}

export const fetchDownloads = createAsyncThunk(
  'downloads/get',
  async (params: {navigate: NavigateFunction, currentPage: number, postsPerPage: number}) => {
    const {currentPage, postsPerPage} = params;
    // const response = await get("books.json");
    const response = await apiRequestDownloads(currentPage, postsPerPage);
    await checkRedirect(params, response);
    // console.log("response", response);
    return {
      downloads: response.data || [],
      pagination: response.pagination || {},
    };
  },
)

export const downloadsSlice = createSlice({
  name: 'downloads',
  initialState,
  reducers: {
    setDownloadsPaginationPage: (state, action: PayloadAction<number>) => {
      state.pagination.currentPage = action.payload;
    },
    clearDownloads: (state) => {
      state.downloads = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchDownloads.pending, (state) => {
        state.downloadsStatus = "loading"
      })
      .addCase(fetchDownloads.fulfilled, (
        state,
        action:PayloadAction<{downloads: EBook[], pagination: PaginationInterface}>
      ) => {
        state.downloadsStatus = "succeeded";
        if (Array.isArray(action.payload.downloads)) {
          state.downloads = action.payload.downloads;
        }
        if (action.payload.pagination?.totalPages) {
          state.pagination.totalPages = action.payload.pagination.totalPages;
        }
        if (action.payload.pagination?.totalRecords) {
          state.pagination.totalRecords = action.payload.pagination.totalRecords;
        }
      })
      .addCase(fetchDownloads.rejected, (state) => {
        state.downloadsStatus = "failed"
      })
  }
});

export const { setDownloadsPaginationPage, clearDownloads } = downloadsSlice.actions;

export default downloadsSlice.reducer